import { createIcon } from '@chakra-ui/react';

export const ContactOutlineIcon = createIcon({
  displayName: 'ContactOutlineIcon',
  path: (
    <>
      <svg viewBox="0 0 44 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M27.3999 20.98C24.3799 20.98 21.9199 18.52 21.9199 15.5C21.9199 12.48 24.3799 10 27.3999 10C30.4199 10 32.8799 12.46 32.8799 15.5C32.8799 18.52 30.4199 20.98 27.3999 20.98ZM27.3999 13C26.0199 13 24.9199 14.12 24.9199 15.5C24.9199 16.88 26.0399 17.98 27.3999 17.98C28.7599 17.98 29.8799 16.86 29.8799 15.5C29.8799 14.12 28.7799 13 27.3999 13Z"
          fill="currentColor"
        />
        <path
          d="M35.4004 33C34.5804 33 33.9004 32.32 33.9004 31.5C33.9004 28.74 30.9804 26.48 27.4004 26.48C23.8204 26.48 20.9004 28.72 20.9004 31.5C20.9004 32.32 20.2204 33 19.4004 33C18.5804 33 17.9004 32.32 17.9004 31.5C17.9004 27.08 22.1604 23.48 27.4004 23.48C32.6404 23.48 36.9004 27.08 36.9004 31.5C36.9004 32.32 36.2204 33 35.4004 33Z"
          fill="currentColor"
        />
        <path
          d="M33.9998 43H15.7197C10.4797 43 6.21973 38.74 6.21973 33.5V29.12C6.21973 28.3 6.89973 27.62 7.71973 27.62H9.41975C10.7997 27.62 11.9197 26.5 11.9197 25.12V15.98C11.9197 14.6 10.7997 13.48 9.41975 13.48H7.71973C6.89973 13.48 6.21973 12.8 6.21973 11.98V9.5C6.21973 4.26 10.4797 0 15.7197 0H33.9998C39.2398 0 43.4998 4.26 43.4998 9.5V33.5C43.4998 38.74 39.2398 43 33.9998 43ZM9.21973 30.62V33.5C9.21973 37.08 12.1397 40 15.7197 40H33.9998C37.5798 40 40.4998 37.08 40.4998 33.5V9.5C40.4998 5.92 37.5798 3 33.9998 3H15.7197C12.1397 3 9.21973 5.92 9.21973 9.5V10.48H9.41975C12.4597 10.48 14.9197 12.94 14.9197 15.98V25.12C14.9197 28.16 12.4597 30.62 9.41975 30.62H9.21973Z"
          fill="currentColor"
        />
        <path
          d="M9.42002 30.62H6C2.96 30.62 0.5 28.16 0.5 25.12V15.98C0.5 12.94 2.96 10.48 6 10.48H9.42002C12.46 10.48 14.92 12.94 14.92 15.98V25.12C14.92 28.16 12.46 30.62 9.42002 30.62ZM6 13.48C4.62 13.48 3.5 14.6 3.5 15.98V25.12C3.5 26.5 4.62 27.62 6 27.62H9.42002C10.8 27.62 11.92 26.5 11.92 25.12V15.98C11.92 14.6 10.8 13.48 9.42002 13.48H6Z"
          fill="currentColor"
        />
      </svg>
    </>
  ),
});
